import { render, staticRenderFns } from "./TransactionCheckListItem.vue?vue&type=template&id=1a453b23&scoped=true"
import script from "./TransactionCheckListItem.vue?vue&type=script&lang=js"
export * from "./TransactionCheckListItem.vue?vue&type=script&lang=js"
import style0 from "./TransactionCheckListItem.vue?vue&type=style&index=0&id=1a453b23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a453b23",
  null
  
)

export default component.exports